'use client';

import React from 'react';
import HeroSection from './HeroSection';
import { SlideUp } from '@/components/ui/motion';
import FeaturedPetsSection from './FeaturedPetsSection';
import SuccessStoriesSection from './SuccessStoriesSection';
import CareGuidesPreview from './CareGuidesPreview';
import AdoptionProcessOverview from './AdoptionProcessOverview';
import TrustSignals from './TrustSignals';
import CTASection from './CTASection';
import NewsletterSection from './NewsletterSection';
import Footer from './Footer';

interface FeaturedPet {
  id: string;
  name: string;
  species: string;
  breed: string;
  age: string;
  image: string;
  alt: string;
  story: string;
}

interface Pet {
  id: string;
  name: string;
  species: string;
  breed: string;
  age: string;
  gender: string;
  location: string;
  image: string;
  alt: string;
  traits: string[];
}

interface SuccessStory {
  id: number;
  petName: string;
  ownerName: string;
  location: string;
  adoptionDate: string;
  story: string;
  beforeImage: string;
  beforeAlt: string;
  afterImage: string;
  afterAlt: string;
}

interface CareGuide {
  id: number;
  title: string;
  category: string;
  description: string;
  readTime: string;
  image: string;
  alt: string;
  icon: string;
}

interface ProcessStep {
  id: number;
  title: string;
  description: string;
  icon: string;
}

interface Partner {
  id: number;
  name: string;
  logo: string;
  alt: string;
}

interface Testimonial {
  id: number;
  name: string;
  role: string;
  organization: string;
  quote: string;
  image: string;
  alt: string;
}

interface HomepageInteractiveProps {
  featuredPets: FeaturedPet[];
  pets: Pet[];
  successStories: SuccessStory[];
  careGuides: CareGuide[];
  processSteps: ProcessStep[];
  partners: Partner[];
  testimonials: Testimonial[];
}

const HomepageInteractive = ({
  featuredPets,
  pets,
  successStories,
  careGuides,
  processSteps,
  partners,
  testimonials,
}: HomepageInteractiveProps) => {
  return (
    <div className="flex flex-col gap-0">
      <HeroSection featuredPets={featuredPets} />

      <SlideUp delay={0.1}>
        <FeaturedPetsSection pets={pets} />
      </SlideUp>

      <SlideUp delay={0.1}>
        <SuccessStoriesSection stories={successStories} />
      </SlideUp>

      <SlideUp delay={0.1}>
        <CareGuidesPreview guides={careGuides} />
      </SlideUp>

      <SlideUp delay={0.1}>
        <AdoptionProcessOverview steps={processSteps} />
      </SlideUp>

      <SlideUp delay={0.1}>
        <TrustSignals partners={partners} testimonials={testimonials} />
      </SlideUp>

      <SlideUp delay={0.1}>
        <CTASection />
      </SlideUp>

      <SlideUp delay={0.1}>
        <NewsletterSection />
      </SlideUp>

      <Footer />
    </div>
  );
};

export default HomepageInteractive;